/**
 * Layout: Theme
 * -----------------------------------------------------------------------------
 * Entry file for all global theme scripts.
 *
 */
import '@/layout/theme.scss'

import AppHandler from '~/core/app-handler'
import Bugsnag from '~/core/bugsnag'
import Canvas from '~/core/canvas'
import Commands from '~/core/commands'
import EventBus from '~/core/event-bus'
import { focus, reportError, sleep } from '~/core/global-functions'
import Quicklink from '~/core/quicklink'
import Query from '~/core/query'
import { domReady } from '~/core/runners'
import TagHandler from '~/core/tag-handler'

/**
 * Global Canvas variables.
 */
window.cnvs = window.cnvs || {}
window.cnvs.started = false

/**
 * Global Canvas functions.
 */
window.cnvs.EventBus = EventBus()
window.cnvs.Helpers = Commands().cli()
window.cnvs.Query = (query, useCache) => Query(query, useCache)

window.cnvs.Focus = focus
window.cnvs.ReportError = reportError
window.cnvs.Sleep = sleep

/**
 * DOM ready.
 */
domReady(() => {
  Bugsnag().init()
  Commands().init()

  AppHandler().beforeVueInit()
  TagHandler().init()
  Canvas().init()
  AppHandler().afterVueInit()

  Quicklink().init()

  /**
  * Apply styling to pages listed in formsAppStyle, within the Forms App.
  */
  const formsAppStyle = window.cnvs.settings.formsAppStyle || []
  const currentPath = window.location.pathname
  const shouldApplyStyles = formsAppStyle.some(page => currentPath.includes(page))

  if (shouldApplyStyles) {
    const applyStyles = () => {
      const formEmbed = document.querySelector('form-embed')
      if (formEmbed && formEmbed.shadowRoot) {
        const projectElement = formEmbed.shadowRoot.querySelector('#form-container-ref > section > section')
        if (projectElement) {
          projectElement.style.maxWidth = '682px'
        }

        const gridItemElement = formEmbed.shadowRoot.querySelector('#form-container-ref > section > section > div:nth-child(2)')
        gridItemElement.style.paddingInlineEnd = 'var(--layout-margin)'
        gridItemElement.style.paddingInlineStart = 'var(--layout-margin)'
      }
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.matches('form-embed')) {

            const childObserver = new MutationObserver((childMutations) => {
              childMutations.forEach((childMutation) => {
                childMutation.addedNodes.forEach((childNode) => {
                  if (childNode.nodeType === 1 && childNode.matches('#form-container-ref > section > section')) {
                    applyStyles()
                    childObserver.disconnect()
                  }
                })
              })
            })
            childObserver.observe(node.shadowRoot, { childList: true, subtree: true })
          }
        })
      })
    })

    observer.observe(document.body, { childList: true, subtree: true })

    const retryInterval = setInterval(() => {
      const formEmbed = document.querySelector('form-embed')
      if (formEmbed && formEmbed.shadowRoot) {
        applyStyles()
        clearInterval(retryInterval)
      }
    }, 100)

    applyStyles()
  }
})
